module.exports = __webpack_public_path__ + "img/department_icon1.c95eb5fd.png";